const routes = [{
  path: '/account',
  component: () => import('@/views/account'),
  name: 'account',
  meta: {
    title: '账号分配'
  }
}, {
  path: '/account/security',
  component: () => import('@/views/account/security'),
  name: 'account-security',
  meta: {
    title: '账号安全'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/account.js